module.exports = __webpack_public_path__ + "img/img_1.934101aa.png";